/**
 * @deprecated use same function from '@rchh/lowcode-utils' instead
 */
export function isProjectSchema(data) {
  return data && data.componentsTree;
}